import axios from 'axios';
import { useQuery } from 'react-query';
import { SubscriptionDto } from '../../model/types';

const SUBSCRIPTION = `/api/admin/subscription`;

export const useGetSubscriptions = () => {
	return useQuery<SubscriptionDto[]>(
		['subscriptions'],
		async () => {
			const { data } = await axios.get(`${SUBSCRIPTION}/`);
			return data.data;
		},
		{
			refetchOnWindowFocus: false,
		}
	);
};
